var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollectionsMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 0H1.75C0.78349 0 0 0.78349 0 1.75V17.4964C0 18.3969 0.976719 18.9576 1.75437 18.5041L7 15.4438L12.2464 18.5037C13.0229 18.9255 14 18.3969 14 17.4964V1.75C14 0.78349 13.2161 0 12.25 0ZM12.25 16.4792L7 13.4167L1.75 16.4792V1.96875C1.75 1.84589 1.84589 1.75 1.93594 1.75H11.9984C12.1552 1.75 12.25 1.84589 12.25 1.96875V16.4792Z",
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectionsMobileIcon);
export default __webpack_public_path__ + "static/media/collections-mobile-icon.ab24d7ab9bce63729305b8b078b9bfd1.svg";
export { ForwardRef as ReactComponent };